import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, NgForm, Validators } from '@angular/forms';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { AuthService, DialogModalService, NotificationService, ValidatorsService } from 'src/app/services';
import { ConfirmEmailComponent } from '../../dialog/registration/confirm-email/confirm-email.component';
import { RegistrationValidator } from './registration.validator';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.css']
})
export class RegistrationComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  errorMessages: any;
  confirm_email: any;
  showPass: boolean;
  showPassConfirm: boolean;

  registrationForm: UntypedFormGroup = this.fb.group({
    login: [null, this.validator.login],
    password: [null, this.validator.password],
    confirm_password: [null, this.validator.confirm_password],
    first_name: [null, this.validator.first_name],
    last_name: [null, this.validator.last_name],
    second_name: [null, this.validator.second_name],
    mail_code: [null]
  },
    {
      validator: this.validatorService.mustMatch('password', 'confirm_password')
    });

  constructor(
    public ngProgress: NgProgress,
    private fb: UntypedFormBuilder,
    private authService: AuthService,
    private validator: RegistrationValidator,
    private validatorService: ValidatorsService,
    private notification: NotificationService,
    private dialogModal: DialogModalService
  ) { }

  ngOnInit() {

    this.registrationForm.get('login').valueChanges.subscribe(val => {

      this.confirm_email = val;

    });

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.errorMessages = this.validator.errorMessages;
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }


  /**
   * 
   * @param form 
   */
  registration(form: NgForm): void {


    console.log("FORM: ", form);
    

    this.authService.registration(this.registrationForm.value, this.progressRef, form);
  }


  /**
   * 
   * @param field 
   * @param type 
   */
  validation(field: string, type: string): boolean {

    return this.validatorService.validation(this.registrationForm.get(field), type);
  }


  /**
   * 
   * @param field 
   */
  checkingFieldStatus(field: string): string {

    return this.validatorService.checkingFieldStatus(this.registrationForm.get(field));
  }


  /**
   * 
   * @param hide 
   */
  password(hide: string) {

    if (hide == 'showPass') {

      this.showPass = !this.showPass;

    }
    else  {
      this.showPassConfirm = !this.showPassConfirm;
    }
  }


  /**
   * 
   */
  onConfirm(f: NgForm) {

    let form = f;

    let data = {
      email: this.confirm_email
    }

    this.dialogModal.open(data, ConfirmEmailComponent, 'lg').then(

      (result) => {

        if (result) {

          this.registrationForm.get('mail_code').setValue(result)

          this.registration(form);
          

        } else {

          this.notification.show('danger', 'Код введен не верно!');
        }
      },
      () => { console.log('Rejected!'); }
    );

  }

}
